export default __webpack_public_path__ + "static/icon-7-1-5d918a28c554a2aefbc886848a60afc2.png";